import { useState, useEffect } from 'react';
import { useApi } from '../../../../hooks/useApi';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { Grid } from 'gridjs-react';
import { columns } from './columns';

const LoansActive = () => {
  const api = useApi();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  });

  useEffect(() => {
    fetchLoansByCooperative();
  }, []);

  const fetchLoansByCooperative = async (page = pagination.page) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        status: 'active',
        limit: pagination.limit.toString()
      });
      
      const profile = JSON.parse(localStorage.getItem('user_profile'));
      const cooperativeId = profile?.cooperative.id || 0; // Fallback to 1 if cooperative ID is not available
      const response = await api.get(`/cooperatives/${cooperativeId}/loans?${params}`);
      
      if (response && response.data) {
        setList(response.data);
        setPagination(prev => ({
          ...prev,
          page: response.pagination?.current_page || page,
          total: response.pagination?.total || 0,
          totalPages: response.pagination?.total_pages || 1
        }));
      } else {
        setList([]);
      }
    } catch (error) {
      console.error('Failed to load loan:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load loan. Please try again.'
      });
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        <nav className="flex mb-6" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-3">
                <li className="inline-flex items-center">
                    <Link 
                        to="/dashboard"
                        className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600"
                    >
                        <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                        </svg>
                        Dashboard
                    </Link>
                </li>
                <li>
                    <div className="flex items-center">
                        <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
                        </svg>
                        <button
                            onClick={() => navigate('/admin/loans-active')}
                            className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
                        >
                            List Pinjaman Berlangsung
                        </button>
                    </div>
                </li>
            </ol>
        </nav>
      
      <div className="flex flex-auto flex-col">
        <div className="card">
          <div className="card-header">
            <div className="flex justify-between items-center">
              <h4 className="card-title">List Pinjaman Berlangsung</h4>
              <div className="flex gap-2">
                <button 
                  className="btn btn-sm bg-secondary text-white"
                  onClick={() => fetchLoansByCooperative(1)}
                  disabled={loading}
                >
                  <i className="mgc_refresh_1_line me-2"></i>Refresh
                </button>
                <button className="btn btn-sm bg-info text-white">
                  <i className="mgc_filter_line me-2"></i>Filter
                </button>
              </div>
            </div>
          </div>
          
          <div className="p-6">
            <div className="overflow-x-auto">
              <Grid
                data={list}
                columns={columns}
                pagination={true}
                search={true}
                sort={true}
                style={{
                    td: {
                        'text-align': 'center',
                    },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoansActive;
